module.exports = __webpack_public_path__ + "img/app-phone.70d1d216.svg";